// extracted by mini-css-extract-plugin
export default {"container":"GlobalNav_container__ckKX2","demoButton":"GlobalNav_demoButton__ofirF"};